import { useLayoutEffect } from 'react';
import { useLexicalComposerContext } from '@lexical/react/LexicalComposerContext';
import { $selectAll } from 'lexical';

// Related issue: https://github.com/facebook/lexical/issues/4658
// When you Cmd + a the text content and try to delete it, it removes the content from the start to the first node it finds.
// To replicate this you need to have a non-text Node at the end of the editor.
export const CustomSelectAllShortcutPlugin = () => {
  const [editor] = useLexicalComposerContext();

  useLayoutEffect(() => {
    const onKeyDown = (event: KeyboardEvent) => {
      if (event.metaKey && event.key === 'a') {
        event.preventDefault();
        event.stopPropagation();

        editor.update(() => {
          $selectAll();
        });
      }
    };

    return editor.registerRootListener(
      (rootElement: HTMLElement | null, prevRootElement: HTMLElement | null) => {
        if (prevRootElement !== null) {
          prevRootElement.removeEventListener('keydown', onKeyDown, true);
        }
        if (rootElement !== null) {
          rootElement.addEventListener('keydown', onKeyDown, true);
        }
      },
    );
  }, [editor]);

  return null;
};
